import React from 'react';
import PropTypes from 'prop-types';
import { ExperimentProvider } from '@americanexpress/one-xp-client-sdk';
import { isOneXpEnabled } from '../utils';

const OneXp = ({ locale, pathname, children }) => {
  if (isOneXpEnabled({ locale, pathname })) {
    return <ExperimentProvider>{children}</ExperimentProvider>;
  }
  return children;
};

OneXp.propTypes = {
  locale: PropTypes.string,
  pathname: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default OneXp;
